import {Client, createClient, getRepositoryEndpoint} from '@prismicio/client';
import {useGuestHost, useRuntimeConfig} from '#imports';
import {routes} from '../../helpers/link-resolver';

export default function usePrismicClient(): Client {
    const runtimeConfig = useRuntimeConfig().public;

    const prismicCacheEnabled = runtimeConfig.prismicCacheEnabled as boolean | undefined;
    const prismicAccessToken = runtimeConfig.prismicAccessToken as string | undefined;
    const prismicRepository = runtimeConfig.prismicRepository as string | undefined;

    if (!prismicRepository) {
        throw new Error('Prismic repository not defined in configuration.');
    }

    if (prismicCacheEnabled) {
        const host = useGuestHost();

        return createClient(prismicRepository, {
            documentAPIEndpoint: host + '/cms/api/prismic',
            accessToken: prismicAccessToken,
            routes,
        });
    } else {
        if (!prismicAccessToken) {
            throw new Error('Prismic token not defined in configuration.');
        }

        return createClient(prismicRepository, {
            documentAPIEndpoint: getRepositoryEndpoint(prismicRepository),
            accessToken: prismicAccessToken,
            routes,
        });
    }
}

export {Client as PrismicClient};
